<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('generate.page.subtitle') }}
        </span>
        <h3 class="page-title d-inline">
          {{ $t('generate.page.title') }}
        </h3>
      </d-col>
    </d-row>
    <!-- Content -->
    <d-row>
      <d-col cols="12" class="col-md">
        <d-card class="mb-4 card-small">
          <!-- Card Header -->
          <d-card-header class="border-bottom">
            <d-row class="align-items-center">
              <d-col cols="12" lg="6">
                <h6 class="m-0">
                  {{ $t('generate.card.title') }}

                  <i
                    id="generate-help"
                    class="fas fa-question-circle ml-2"
                    style="cursor: pointer"
                  />

                  <d-popover
                    target="generate-help"
                    placement="auto"
                    :triggers="['hover']"
                  >
                    <template slot="title">
                      {{ $t('generate.help.title') }}
                    </template>

                    <template>
                      <ol class="pl-3 mb-0 help-list">
                        <li
                          v-for="(step, index) in $t('generate.help.steps')"
                          :key="index"
                        >
                          {{ step }}
                        </li>
                      </ol>
                    </template>
                  </d-popover>
                </h6>
              </d-col>
            </d-row>
          </d-card-header>

          <d-list-group flush>
            <d-list-group-item class="p-3">
              <d-row>
                <d-col>
                  <generate-form ref="generateFormRef" />
                </d-col>
              </d-row>
            </d-list-group-item>
          </d-list-group>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import GenerateForm from '../components/GenerateForm.vue';

export default {
  name: 'generate-page',
  components: {
    GenerateForm,
  },
  computed: {},
  data() {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.help-list {
  font-size: 0.95rem;
}
</style>
